import { SizeBucketLabelMap } from '../configs/blueberrySizeBucketLabelsDeprecated';
import { useBlueberryConfig } from './useBlueberryConfig';

/**
 * Get the labels for blueberry size buckets
 * @returns {SizeBucketLabelMap | null} A label mapping, or null if blueberry
 * size buckets are unavailable for the current service/version
 */
export const useBlueberrySizeBucketLabels = (): SizeBucketLabelMap | null => {
  const config = useBlueberryConfig();

  if (!config || !config.hasSizeBuckets) {
    return null;
  }

  return config.sizeBucketLabels;
};
